import { mapSearchFormBySection } from '_app/utils/mapper';

export const buildSearchSections = (items = []) => mapSearchFormBySection(items);

export const findSearchItem = (items = [], name) => items.find((item) => item.name === name) || null;

export const updateSearchItem = (items = [], updatedItem) =>
  items.map((item) => {
    if (item.name !== updatedItem.name) {
      return item;
    }

    return { ...item, ...updatedItem };
  });

export const serializeSearchForm = (items = []) => {
  const formData = new FormData();

  items
    .filter((item) => !!item.value || item.value === 0 || item.value === '0')
    .forEach((item) => {
      if (Array.isArray(item.value)) {
        item.value.forEach((value) => {
          formData.append(item.name, value);
        });
        return;
      }

      formData.append(item.name, item.value);
    });

  return formData;
};
